import * as FieldValidation from '../shared/field-validation.js';
import { getDafCardTypeHandler } from '../manager/pledges/daf-card-type-handlers.js';

let initialized = false;

function currentDafType(row) {
    const prevBtn = row.querySelector('.manual-card-form__card-type.is-selected');
    return prevBtn ? (prevBtn.getAttribute('data-card-type') || 'credit') : '';
}

function clearPrefixedCardFields(prefix) {
    ['card', 'cvv2', 'expiry_month', 'expiry_year', 'avs_zip'].forEach(function (name) {
        const el = document.getElementById((prefix || '') + name);
        if (el) {
            el.value = '';
        }
    });
}

function onDafChoiceActivate(el) {
    const row = el.closest('.mgr-daf-choice-row');
    if (!row) return;
    row.querySelectorAll('.manual-card-form__card-type').forEach(function (btn) {
        btn.classList.remove('is-selected');
        btn.setAttribute('aria-pressed', 'false');
    });
    el.classList.add('is-selected');
    el.setAttribute('aria-pressed', 'true');
}

function dispatchDafBehavior(prefix, type) {
    const fn = getDafCardTypeHandler(prefix);
    if (typeof fn === 'function') fn(type);
}

function activateDafChoiceFromClick(btn) {
    const row = btn.closest('.mgr-daf-choice-row');
    if (!row) return;
    const prefix = row.getAttribute('data-daf-prefix') || '';
    const type = btn.getAttribute('data-card-type') || 'credit';
    const prev = currentDafType(row);
    if (prev && prev !== type) {
        clearPrefixedCardFields(prefix);
    }
    onDafChoiceActivate(btn);
    dispatchDafBehavior(prefix, type);
}

export function setDafCardType(prefix, type) {
    document.querySelectorAll('.mgr-daf-choice-row[data-daf-prefix="' + prefix + '"]').forEach(function (row) {
        const prev = currentDafType(row);
        const btn = row.querySelector('.manual-card-form__card-type[data-card-type="' + type + '"]');
        if (prev && type && prev !== type) {
            clearPrefixedCardFields(prefix);
        }
        if (btn) onDafChoiceActivate(btn);
    });
    dispatchDafBehavior(prefix, type);
}

function initDafCardChoiceUi() {
    document.addEventListener('click', function (e) {
        const btn = e.target && e.target.closest ? e.target.closest('.mgr-daf-choice-row .manual-card-form__card-type') : null;
        if (!btn) return;
        activateDafChoiceFromClick(btn);
    });

    document.addEventListener('keydown', function (e) {
        const btn = e.target && e.target.closest ? e.target.closest('.mgr-daf-choice-row .manual-card-form__card-type') : null;
        if (!btn) return;
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        btn.click();
    });
}

export function ccEntrySyncManualCcState(opts) {
    const options = opts || {};
    const prefix = String(options.idPrefix || '');
    const enabled = Boolean(options.manualEnabled);
    const requireBase = Boolean(options.requireBaseManualFields);
    const requireZipCvv = Boolean(options.requireZipAndCvv);

    const id = (suffix) => `#${prefix ? prefix + '_' : ''}${suffix}`;

    FieldValidation.applyCardConstraints(document);

    const $base = $(`${id('name')},${id('card')},${id('expiry_month')},${id('expiry_year')}`);
    const $zipCvv = $(`${id('cvv2')},${id('avs_zip')}`);
    const $all = $base.add($zipCvv);

    $all.prop('disabled', !enabled);
    $base.prop('required', enabled && requireBase);
    $zipCvv.prop('required', enabled && requireZipCvv);
    FieldValidation.syncCvvFieldForCardType($(id('cvv2')), options.cardType || (requireZipCvv ? 'credit' : 'pledger'));
    if (!enabled) {
        $(id('cvv2')).prop('disabled', true);
    }
    FieldValidation.clearValidity($all);
}

export function initCreditCardEntry() {
    if (initialized) {
        return;
    }
    initialized = true;
    FieldValidation.applyCardConstraints(document);
    initDafCardChoiceUi();
}
